import React from "react";
import { faDizzy, faGrinSquintTears, faGrinStars, faHeart } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ReactionType } from "@/gql/generated/graphql";

type ReactionProps = {
  type: string;
};

const iconMap = {
  [ReactionType.Dizzy]: faDizzy,
  [ReactionType.Laugh]: faGrinSquintTears,
  [ReactionType.Stars]: faGrinStars,
  [ReactionType.Love]: faHeart
}


const Reaction = function ({ type }: ReactionProps) {
  if (
    type === ReactionType.Dizzy ||
    type === ReactionType.Laugh ||
    type === ReactionType.Love ||
    type === ReactionType.Stars
  ) {
    return <FontAwesomeIcon icon={iconMap[type]} />;
  } else return null;
};

export default Reaction;
